import * as React from 'react'
import { useIntl } from 'react-intl'
import BedbankSearchTileWalledContent from './BedbankSearchTileWalledContent'
import BedbankSearchTileSignUpButton from './BedbankSearchTileSignUpButton'
import { EmptyObject } from 'lib/object/objectUtils'
import SearchTilePrimaryActionButton from '../shared/SearchTilePrimaryActionButton'
import TextButton from 'LuxKit/Button/TextButton'
import { checkBypassMode } from 'marketing/lib/lib'
import { isBedbankUniqueStaysOffer } from 'lib/offer/offerTypes'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
  utmBp?: string
  onSelectDatesClick?: () => void
  hidePricing?: boolean
  isAnytimeSearch?: boolean
}

function BedbankSearchTileAction({
  offer,
  filters = EmptyObject,
  utmBp,
  onSelectDatesClick,
  hidePricing = false,
  isAnytimeSearch = false,
}: Props) {
  const intl = useIntl()
  // Only on bedbank titles when bp=2 is set and the user isn't logged in. Clicking on "Login for member savings" triggers the login modal.
  const isLoginForMemberSavings = checkBypassMode(utmBp)
  const hidePrice = hidePricing || offer.hidePricing

  // Label must match what clicking the tile actually does (see OfferSearchTile/
  // GroupedBedbankSearchTile's isNhaForceDatesEligible): UNIQUE_STAYS anytime search forces
  // date selection on click regardless of whether price is shown (utmBp/paid-search sessions
  // keep seeing price but still get the date prompt), so the CTA must say "Select dates" then
  // too, not just when hidePrice happens to be true.
  const shouldPromptForDates = isAnytimeSearch && isBedbankUniqueStaysOffer(offer)

  const handleSelectDatesClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (shouldPromptForDates && onSelectDatesClick) {
      e.preventDefault()
      onSelectDatesClick()
    }
  }

  const actionButton = shouldPromptForDates && onSelectDatesClick ? (
    <TextButton nonInteractable kind="primary" onClick={handleSelectDatesClick}>
      {intl.formatMessage({
        id: 'qBTPc0sN1iCq7uv1ODCV',
        defaultMessage: 'Select dates',
        description: 'Button text prompting user to select dates on bedbank search tile',
      })}
    </TextButton>
  ) : (
    <SearchTilePrimaryActionButton />
  )

  return <BedbankSearchTileWalledContent
    wall={<BedbankSearchTileSignUpButton isLoginForMemberSavings={isLoginForMemberSavings} />}
    offer={offer}
    filters={filters}
    hidePricing={hidePrice}
  >
    {actionButton}
  </BedbankSearchTileWalledContent>
}

export default BedbankSearchTileAction
